import Pill, { PillProps } from "@components/common/Pill";
import { JustifyContent, UIColor } from "@lib/types/generic";
import { useState } from "react";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import { Group, Showcase } from "./StyleGuide";

const Pills = () => {
  const sizes = ["extra-small", "small", "medium", "large", "extra-large"] as PillProps["size"][];

  const [color, setColor] = useState<UIColor>("purple");
  const [textColor, setTextColor] = useState<UIColor>("white");
  const [iconColor, setIconColor] = useState<UIColor>("white");
  const [variant, setVariant] = useState<PillProps["variant"]>("contained");
  const [justifyContent, setJustifyContent] = useState<JustifyContent>("space-between");
  const [rounded, setRounded] = useState<boolean>(false);

  const props = {
    color,
    textColor,
    iconColor,
    variant,
    justifyContent,
    rounded,
  };

  return (
    <Showcase
      title="Pills"
      className="pills"
      colors={[
        {
          color: color,
          label: "Color",
          onChange: setColor,
        },
        {
          color: textColor,
          label: "Text Color",
          onChange: setTextColor,
        },
        {
          color: iconColor,
          label: "Icon Color",
          onChange: setIconColor,
        },
      ]}
      selects={[
        {
          value: variant ?? "contained",
          optionsArray: ["contained", "outlined", "flat", "transparent"],
          label: "Variant",
          onChange: setVariant,
        },
        {
          value: justifyContent,
          optionsArray: ["space-between", "flex-start", "center", "flex-end"],
          label: "Justify",
          onChange: setJustifyContent,
        },
      ]}
      checkboxes={[
        {
          value: rounded,
          label: "Rounded",
          onChange: setRounded,
        },
      ]}>
      {sizes.map(size => (
        <Group key={size}>
          <Pill size={size} {...props}>
            Pill
          </Pill>
          <Pill size={size} endIcon={<IoArrowForward />} {...props}>
            Pill
          </Pill>
          <Pill size={size} startIcon={<IoArrowBack />} {...props}>
            Pill
          </Pill>
          <Pill size={size} startIcon={<IoArrowBack />} endIcon={<IoArrowForward />} {...props}>
            Pill
          </Pill>
        </Group>
      ))}
    </Showcase>
  );
};

export default Pills;
